import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";

/**
 * @namespace akademika.akamont.pages.workOrderToPdf
 */
export default class WorkOrderToPdf extends BaseController {
  route = Routes.WORK_ORDER_TO_PDF;
  parentRoute = Routes.WORK_ORDER_DETAILS_PARTNER;

  public async onRouteMatched() {
    await this.fetchModel(
      "api/WorkOrder/GetWorkOrderDetailsForPartner/" +
        this.routeParams.workOrderId
    );
  }

  public backToDetails() {
    const workOrderId = this.routeParams.workOrderId;
    this.navTo(this.parentRoute, { workOrderId });
  }
}
